import { useContext, useState } from "react"
import Select from "react-select";
import ajaxStudent from "../../../util/remote/ajaxStudent";
import SchoolContext from "../../../Context/SchoolContext";
import Loader from "../../Common/Loader";
import SystemModal from "../../Common/SystemModal";


const PrintFilterForm=(props)=>{

    const [loading, setLoading] = useState(false)
    const {schoolList} = useContext(SchoolContext);
    const [school, setSchool] = useState("");
    const [hasData, setHasData] = useState(false);
    const [localList, setLocalList] = useState([]);
    const handleSearch = async(e) =>{
        e.preventDefault()
        setLoading(true)
        const server_response = await ajaxStudent.printAllStudents(school);
        
        setLoading(false);
        if(server_response.status==="OK"){
            const list = server_response.details.list || [];
            props.g(list);
            setLocalList(list);
            setHasData(list.length > 0);
        }
        else{
            props.g(false)
            setLocalList([]);
            setHasData(false);
        } 
    }

    const handleExport = () => {
        props.h(localList);
    };
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                    <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                    {!hasData? <button 
                        type="button" 
                        className={`btn-fill-md text-light bg-dodger-blue`} 
                        onClick={handleSearch}>Filter<i class="fas fa-check mg-l-15"></i></button>:
                    <button
                        type="button"
                        className="btn-fill-md text-light bg-success ml-2"
                        onClick={handleExport}
                        disabled={!hasData}
                    >
                        Export<i className="fas fa-file-export mg-l-15"></i>
                    </button>}
                    </>
        }
    }

    return(
        <SystemModal
            title="Export Student List"
            id="model-call-filter"
            size="md"
            footer={RenderFooter}
        >  
            
            <div className="mb-4 form-group border-1">
                <label htmlFor="">School</label>
                <Select
                      onChange={(e) => setSchool(e.school_id)}
                      getOptionLabel={(option) => option.school_name}
                      getOptionValue={(option) => option.school_id}
                      isSearchable
                      options={Array.isArray(schoolList) ? schoolList : []}
                      value={
                        Array.isArray(schoolList) &&
                        schoolList.find((value) => value.school_id === school)
                      }
                    />
            </div>
        
       
        </SystemModal>
    )
}

export default PrintFilterForm
